<template>
    <div class="content-wrap">
        <div class="card">
            <div class="card-item" v-if="Object.keys(topData).length > 0">
                <div class="fla">
                    <div class="card-item-title1">不合格项：{{topData.below_standard}}</div>
                    <div class="card-item-title1">不整改：{{topData.refuse_rectify}}</div>
                </div>
                <img class="border-bottom" src="@/assets/images/service/border-bottom.png" alt="" />
                <div class="fla">
                    <div class="card-item-title2">已整改：{{topData.has_rectify}}</div>
                    <div class="card-item-title3">超期整改：{{topData.out_time_rectify}}</div>
                </div>
            </div>
        </div>
        <div class="card2">
            <div v-for="(item1, index1) in AcceptData" :key="index1" :class="[ index1 == 0 ? 'item-top-bor' : '', 'item-box-category']">
                <!-- 大类区分 -->
                <div class="category">{{ item1.parent_name }}</div>
                <!-- 子类区分 -->
                <div v-for="(item2, index2) in item1.child_list" :key="index2" class="subclass">
                    <div class="subclass-titile">{{ item2.child_name }}</div>
                    <div v-for="(item7, index7) in item2.acceptacne_list" :key="index7">
                        <!-- remold 整改前-->
                        <div class="remold remoldOne">
                            <!-- buttom -->
                            <div class="rem-btn btn-one font-text">整改前</div>
                            <!-- titile -->
                            <div class="rem-title">
                                <div>{{ item7.list.before.acceptance_name }}</div>
                                <div>{{ item7.list.before.new_result }}</div>
                            </div>
                            <!-- img -->
                            <div class="rem-img">
                                <template v-for="(item4, index4) in item7.list.before.photo_list">
                                    <div @click="openLook(item4)" :key="index4" v-if="index4 < 3"><img :src="item4" alt=""></div>
                                </template>
                            </div>

                            <!-- odd -->
                            <div class="rem-odd font-tex2">
                                <div>工单号：{{ item7.list.before.project_message.new_name }}</div>
                                <div>施工时间：{{ item7.list.before.project_message.new_actualstartedon }}至{{ item7.list.before.project_message.new_actualfinishedon }}</div>
                                <div>施工负责人：{{ item7.list.before.project_message.project_manager_name }}</div>
                            </div>
                        </div>
                        <!-- remold 整改后-->
                        <div class="remold">
                            <!-- buttom -->
                            <div class="rem-btn btn-tow font-text">整改后</div>
                            <!-- titile -->
                            <div class="rem-title">
                                <div class="div-text">{{ item7.list.after.acceptance_name }}</div>
                                <div>{{ item7.list.after.new_result }}</div>
                            </div>
                            <!-- img -->
                            <div class="rem-img">
                                <template v-for="(item6, index6) in item7.list.after.photo_list">
                                    <div @click="openLook(item6)" :key="index6" v-if="index6 < 3"><img :src="item6" alt=""></div>
                                </template>
                            </div>
                            <!-- odd -->
                            <div class="rem-odd font-tex2">
                                <div>验收工单号：{{ item7.list.after.project_message.new_name }}</div>
                                <div>验收时间：{{ item7.list.after.project_message.new_actualstartedon }}</div>
                                <div>整改完工时间：{{ item7.list.after.project_message.new_actualfinishedon }}</div>
                                <div>验收负责人：{{ item7.list.after.project_message.check_name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="card2" v-for="(item,index) in AcceptData" :key="index">
            <div class="card2-top">
                <span>{{item.parent_name}}</span>
                <img src="@/assets/images/service/drop-down.png" :class="item.status?'rotate':'rotate2'" @click="Specific(index)" alt=""/>
            </div>
            <transition name="fade-transition"  mode="in-out">
            <transition name="fade-transition"  mode="out-in">
                <div v-if="item.status">
                    <div v-for="(item2,index2) in item.child_list" :key="index2">
                        <div class="Fan-panel">
                            <div>{{item2.child_name}}</div>
                        </div>
                        <div v-for="(item3,index3) in item2.acceptacne_list" :key="index3">
                            <div class="Fan-panel-item">
                                <img src="@/assets/images/service/waring.png" alt="" />
                                <div>{{item3.acceptance_name}}</div>
                                <span>{{item3.new_result}}</span>
                            </div>
                            <img
                                class="border-bottom"
                                src="@/assets/images/service/border-bottom.png"
                                alt=""
                                v-if="index3 == item2.acceptacne_list.length - 1"
                            />
                        </div>
                    </div>
                </div>

            </transition>
        </div> -->

        <div class="card2 fla" style="justify-content:center;width:100%;height:300px;font-size:16px;color:#a2a2a2;" v-if="AcceptData.length == 0">
            暂无问题，请继续保持。
        </div>

        <!-- 预览图片 -->
        <van-image-preview v-model="show2" :startPosition="lookImgIndex" :images="images">
            <template v-slot:imgIndex>第{{ imgIndex }}页</template>
        </van-image-preview>
    </div>
</template>

<script>
export default {
    name: "questionanalysis",
    data() {
        return {
            show: true,
            show2: false,//显示图片弹窗
            lookImgIndex: 0,
            images: [],
            imgIndex: 0,

        }
    },
    mounted() {
    },
    methods: {
        openLook(index) {   // 点击预览图片
            this.show2 = true;
            this.images = [index];
        },
        Specific(index) {
            // 修改状态
            this.$store.commit('serviceScoreDetail/changeStatus', index)
        }
    },
    computed: {
        topData() {
            return this.$store.state.serviceScoreDetail.topData
            // return []
        },
        AcceptData() {
            return this.$store.state.serviceScoreDetail.AcceptData
            // return []
        },
    }
};
</script>

<style lang="scss" scoped>
.fade-transition-leave-active,
.fade-transition-enter-active {
  transition: all 0.3s;
}
.fade-transition-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
.fade-transition-enter {
  transform: translateY(-30px);
  opacity: 0;
}
.content-wrap {
  width: 93.6%;
  margin: 0 auto;
  padding-bottom: 50px;
  .card {
    background: #fff;
    padding: 0 24px;
    border-radius: $commonRadius;

    .card-item {
      border-bottom: 2px dashed #f1f1f1;

      &:first-child {
        padding-bottom: 24px;
        .card-item-title1 {
          padding: 20px 0 16px 0;
          // margin-bottom: 16px;
        }
      }
      &:last-child {
        padding-bottom: 18px;
      }

      .card-item-title1 {
        width: 42%;
        font-size: $bigSize;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #eb6f56;
        line-height: 44px;
      }
      .border-bottom {
        width: 652px;
        height: 2px;
      }
      .card-item-title2 {
        width: 42%;
        font-size: $bigSize;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #649559;
        line-height: 44px;
      }
      .card-item-title3 {
        width: 58%;
        font-size: $bigSize;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #444444;
        line-height: 44px;
      }

      .common-item {
        display: flex;
        align-items: flex-start;
        margin-top: 20px;

        img {
          width: 36px;
          height: 36px;
          margin-right: 12px;
        }

        div {
          width: 92.4%;
          font-size: $baseSize;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: $commonText;
          line-height: 40px;
        }
      }

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .card2 {
    padding: 12px 24px;
    background: #ffffff;
    border-radius: 16px;
    border-radius: 16px;
    margin-top: 24px;
    padding-bottom: 14px;

    .item-top-bor {
      margin-top: 0 !important;
      border-top: none !important;
    }

    .item-box-category {
      margin-top: 40px;
      border-top: 1px solid rgba(71, 154, 91, 0.4);
      .category {
        margin-top: 20px;
        font-size: 36px;
        font-weight: 500;
        color: #318544;
      }
      .subclass {
        .subclass-titile {
          margin-top: 20px;
          font-size: 32px;
          font-weight: 500;
          color: #444444;
        }
        .remold {
          border-top: 1px dashed rgba(0, 0, 0, 0.1);
          margin-top: 20px;
          .rem-btn {
            width: 148px;
            height: 60px;
            text-align: center;
            line-height: 60px;
            border-radius: 8px;

            margin-top: 34px;
          }
          .btn-one {
            background: #e7ede8;
            color: $deepGreen;
          }
          .btn-tow {
            background: $deepGreen;
            color: $divBg;
          }
          .rem-title {
            margin-top: 28px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            div:first-of-type {
              font-size: $bigSize;
              font-weight: 400;
            }
            div:last-of-type {
              font-size: $baseSize;
              font-weight: 500;
              color: $warnText;
            }
            .div-text {
              color: $deepGreen;
            }
          }
          .rem-img {
            margin-top: 20px;
            display: flex;
            align-items: center;
            div {
              width: 160px;
              height: 160px;
              background: #f3f3f3;
              border-radius: 12px;
              overflow: hidden;
              margin-right: 24px;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
    .card2-top {
      background: linear-gradient(136deg, #4ea062 0%, #338444 100%);
      border-radius: 12px;
      padding: 28px 24px 28px 28px;
      display: flex;
      justify-content: space-between;
      span {
        font-size: 32px;
        font-weight: 500;
        color: #ffffff;
      }
      img {
        width: 48px;
        height: 48px;
      }
    }
    .Fan-panel {
      padding: 20px 0 20px 24px;
      font-size: 28px;
      font-weight: 500;
      color: #444444;
    }
    .Fan-panel-item {
      padding: 0 24px 14px 24px;
      display: flex;
      line-height: 40px;

      img {
        width: 36px;
        height: 36px;
        margin-right: 8px;
      }
      div {
        flex: 1;
        font-size: 28px;
        padding-right: 74px;
      }
      span {
        font-size: 28px;
        font-weight: 400;
        white-space: nowrap;
        color: #eb6f56;
      }
      .unclear {
        width: 84px;
        font-size: 28px;
        font-weight: 400;
        color: #eb6f56;
      }
    }
    .Fan-panel-img {
      padding: 0 0 20px 28px;
      img {
        width: 148px;
        height: 148px;
        background: #eeeeee;
        margin-right: 18px;
      }
    }
  }
}
/*通用样式*/
.fla {
  display: flex;
  align-items: center;
}
// 图标旋转动画
.rotate {
  transform: rotate(180deg);
  transition: all 0.3s;
}
.rotate2 {
  transform: rotate(0deg);
  transition: all 0.3s;
}
</style>
